import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

const vuexLocal = new VuexPersistence({
    key: 'cambridgepub-ug',
    storage: window.sessionStorage,
    reducer: state => ({
        sidebarShow: state.sidebarShow,
        sidebarMinimize: state.sidebarMinimize,
        client: state.client,
        guides: state.guides,
        timeStamp: state.timeStamp,
        dataLoaded: state.dataLoaded
    })
});

Vue.use(Vuex);

const getUrls = () => {
    if (process.env.NODE_ENV !== 'production') {
        return {
            data: '/dev/data.json',
            checkTimeStamp: '/dev/check_timestamp.json',
            folders: function (guideID) {
                return '/dev/folders.json?id=' + guideID;
            },
            articles: function (folderID) {
                return '/dev/articles.json?id=' + folderID;
            },
            article: function (articleID) {
                return '/dev/article.json?id=' + articleID;
            },
            searchArticles: function (keyword) {
                return '/dev/search_articles.json?id=' + keyword;
            }
        };
    }

    return {
        data: '/api/user_guide/data',
        checkTimeStamp: '/api/user_guide/check_timestamp',
        folders: function (guideID) {
            return '/api/user_guide/folders/' + guideID;
        },
        articles: function (folderID) {
            return '/api/user_guide/articles/' + folderID;
        },
        article: function (articleID) {
            return '/api/user_guide/article/' + articleID;
        },
        searchArticles: function (keyword) {
            return '/api/user_guide/search_articles?keyword=' + keyword;
        }
    };
};

const getDefaultState = () => {
    return {
        sidebarShow: 'responsive',
        sidebarMinimize: false,
        getConfig: {
            body: 'Object',
            method: 'GET',
            responseType: 'json'
        },
        postConfig: {
            body: 'Object',
            method: 'POST',
            responseType: 'json'
        },
        putConfig: {
            body: 'Object',
            method: 'PUT',
            responseType: 'json'
        },
        urls: getUrls(),
        toasts: [],
        client: null,
        guides: null,
        timeStamp: null,
        dataLoaded: false,
        breadcrumbKey: 1,
        sideBarKey: 1
    };
};

const state = getDefaultState();

const mutations = {
	toggleSidebarDesktop(state) {
		const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow);
		state.sidebarShow = sidebarOpened ? false : 'responsive';
	},
	toggleSidebarMobile(state) {
		const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow);
		state.sidebarShow = sidebarClosed ? true : 'responsive';
	},
	set(state, [variable, value]) {
		state[variable] = value;
	},
    add(state, [variable, value]) {
        state[variable].push(value);
    },
    update(state, [variable, value]) {
        const item = state[variable].find(item => item.id === value.id);
        Object.assign(item, value);
    },
    incrementBreadcrumbKey(state) {
        state.breadcrumbKey++;
    },
    incrementSideBarKey(state) {
        state.sideBarKey++;
    },
	toggle(state, variable) {
		state[variable] = !state[variable];
	},
    resetState(state) {
        Object.assign(state, getDefaultState());
    }
};

const store = new Vuex.Store({
	state,
	mutations,
    plugins: [vuexLocal.plugin]
});

export default store;
